import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import _ from "lodash";
import { saveOrganization, updateOrganization } from "@/service/structure";
import { findNodeWithAncestors } from "@/utils/util.js";
import rules from "@/utils/pattern.js";
export default {
  name: "member-add",
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    },
    edit: {
      type: Boolean,
      default() {
        return false;
      }
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    node: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    const h = this.$createElement;
    return {
      styles: {
        height: "calc(100% - 50px)",
        overflow: "hidden",
        paddingBottom: "40px",
        position: "static"
      },
      loading: false,
      form: {
        name: "",
        code: "",
        parentId: ""
      },
      cascaderData: [],
      cascaderValue: [],
      columns: [{
        // lg: 部门名称
        title: $t("iwc4g34", "部门名称"),
        key: "name",
        rules: [{
          required: true,
          // lg: 部门名称不能为空
          message: $t("228u1f8", "部门名称不能为空")
        }, rules.positionName]
      }, {
        // lg: 部门代码
        title: $t("iwb8fy4", "部门代码"),
        key: "code",
        rules: [rules.positionCode],
        renderForm: () => {
          // lg: 未填写，系统将自动生成
          return h("Input", {
            "attrs": {
              "disabled": this.edit,
              "placeholder": $t("suomylb", "未填写，系统将自动生成")
            }
          });
        }
      }, {
        // lg: 上级部门
        title: $t("adlqxp4", "上级部门"),
        renderForm: () => {
          return h("Cascader", {
            "attrs": {
              "data": this.cascaderData,
              "change-on-select": true,
              "clearable": false
            },
            "on": {
              "on-change": (value, selectedData) => {
                let node = selectedData[selectedData.length - 1];
                this.form.parentId = node.orgId;
              }
            },
            "model": {
              value: this.cascaderValue,
              callback: $$v => {
                this.cascaderValue = $$v;
              }
            }
          });
        }
      }]
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isMobile() {
      return window.innerWidth < 768;
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.open();
      }
    }
  },
  methods: {
    close() {
      Object.keys(this.form).forEach(key => {
        this.form[key] = "";
      });
      this.cascaderData = [];
      this.cascaderValue = [];
      this.$refs.proForm.reset();
      this.visible = false;
    },
    open() {
      this.cascaderData = _.cloneDeep(this.data);
      if (this.edit) {
        this.columns[1].disabled = true;
        this.setEditInit();
      } else {
        this.columns[1].disabled = false;
        this.setAddInit();
      }
      this.DG(this.cascaderData);
    },
    setAddInit() {
      let result = findNodeWithAncestors(this.cascaderData, node => node.orgId === this.node.orgId);
      let ancestors = [...result.ancestors, result.node];
      this.cascaderValue = ancestors.map(v => v.orgId);
      this.form.parentId = this.cascaderValue[this.cascaderValue.length - 1];
    },
    setEditInit() {
      this.cascaderData = [this.filterTree(this.cascaderData[0], this.node.orgId)];
      let result = findNodeWithAncestors(this.cascaderData, node => node.orgId === this.node.parentId);
      let ancestors = [...result.ancestors, result.node];
      this.cascaderValue = ancestors.map(v => v.orgId);
      this.form.name = this.node.name;
      this.form.code = this.node.code;
      this.form.parentId = this.cascaderValue[this.cascaderValue.length - 1];
    },
    // 核心函数：过滤掉指定节点及其所有子节点
    filterTree(node, nodeId) {
      // 如果当前节点是要排除的节点，返回null表示移除
      if (node.orgId === nodeId) {
        return null;
      }

      // 如果有子节点，递归处理
      if (node.children && node.children.length) {
        const filteredChildren = [];
        for (const child of node.children) {
          const filteredChild = this.filterTree(child, nodeId);
          if (filteredChild !== null) {
            filteredChildren.push(filteredChild);
          }
        }
        // 返回新节点，包含过滤后的子节点
        return {
          ...node,
          children: filteredChildren
        };
      }

      // 如果没有子节点且不是要排除的节点，直接返回
      return node;
    },
    DG(arr) {
      arr.forEach(v => {
        v.label = v.name;
        v.value = v.orgId;
        if (v.children && v.children.length > 0) {
          this.DG(v.children);
        }
      });
    },
    onSubmit() {
      this.$refs.proForm.validate(valid => {
        if (valid) {
          if (this.edit) {
            this.onSubmitEdit();
          } else {
            this.onSubmitAdd();
          }
        }
      });
    },
    async onSubmitAdd() {
      const params = {
        ...this.form
      };
      this.loading = true;
      let res = await saveOrganization(params);
      this.loading = false;
      if (res.data && res.data.result === 0) {
        // lg: 保存成功
        this.$Message.success($t("aghf564", "保存成功"));
        this.$emit("onSuccess");
        this.close();
      }
    },
    async onSubmitEdit() {
      const params = {
        id: this.node.id,
        ...this.form
      };
      this.loading = true;
      let res = await updateOrganization(params);
      this.loading = false;
      if (res.data && res.data.result === 0) {
        // lg: 保存成功
        this.$Message.success($t("aghf564", "保存成功"));
        this.$emit("onSuccess");
        this.close();
      }
    }
  }
};